module.exports = __webpack_public_path__ + "img/aa662100eaf52fc5287969d2cae7c7ca.png";